import { Footer, Main, Header } from './components';

const App = () => {
  return (
    <>
      <div className='container row'>
        <Header />
        <Main />
      </div>
      <Footer />
    </>
  );
};
export default App;
